var render, staticRenderFns
import script from "./baseProductsAll.vue?vue&type=script&lang=js&"
export * from "./baseProductsAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77327622')) {
      api.createRecord('77327622', component.options)
    } else {
      api.reload('77327622', component.options)
    }
    
  }
}
component.options.__file = "src/components/Flujo/ProductList/baseProductsAll.vue"
export default component.exports